// DEV URL
const devURL = process.env.REACT_APP_DEV_URL || `https://dev.api.holisto.net/`;


// UAT
const uatURL = `https://uat.api.holisto.net/`;

// PROD URL
const prodURL = `https://prod.api.holisto.net/`;

//Live URL
const liveURL = `https://l0xuz8ve59.execute-api.eu-west-1.amazonaws.com/prod/`;

// Staging URL
const stagingURL = `https://staging.api.holisto.net/`;

//Develop URL
const developURL = `https://develop.api.holisto.net/`;

const ENV = process.env?.REACT_APP_ENV;
export let baseURL = "";
export let uiVersion = "";

if (ENV === "development") {
  baseURL = devURL;
  uiVersion = "dev-2";
} else if (ENV === "uat") {
  baseURL = uatURL;
  uiVersion = "uat-12";
} else if (ENV === "prod") {
  baseURL = prodURL;
  uiVersion = "prod-15";
} else if (ENV === "live") {
  baseURL = liveURL;
  uiVersion = "prod-15";
} else if (ENV === "staging") {
  baseURL = stagingURL;
  uiVersion = "prod-15";
} else if (ENV === "develop") {
  baseURL = developURL;
  uiVersion = "prod-15";
}

export const MASTER_PERMISSION = 2048;
export const SUPER_ADMIN_PERMISSION = 131072;

// Insights Dashboard defaults — 0 means the default range is just today
// (from = today - 0 days = today, to = today). Keep at 0 unless product
// asks for a longer default window.
export const INSIGHTS_DEFAULT_DATE_RANGE_DAYS = 0;

// Botpress Webchat Client ID
export const BOTPRESS_CLIENT_ID = process.env?.REACT_APP_BOTPRESS_CLIENT_ID;
